import { render, staticRenderFns } from "./ContactPersonBasicInfo.vue?vue&type=template&id=48e6b1b4&scoped=true"
import script from "./ContactPersonBasicInfo.vue?vue&type=script&setup=true&lang=ts"
export * from "./ContactPersonBasicInfo.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ContactPersonBasicInfo.vue?vue&type=style&index=0&id=48e6b1b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48e6b1b4",
  null
  
)

export default component.exports